import React from 'react'
import { generatePath, Redirect, Route } from 'react-router-dom'

const LEGACY_REDIRECTS: Array<[string, string]> = [
  ['app/add-ons/open-api/view', 'app/integrations/api'],
  ['app/add-ons/open-api/keys/create', 'app/integrations/api/keys/create'],
  ['app/add-ons/open-api/keys/:keyId/edit', 'app/integrations/api/keys/:keyId/edit'],
  ['app/add-ons/open-api/keys/:keyId', 'app/integrations/api/keys/:keyId'],
  ['app/add-ons/open-api/webhooks', 'app/integrations/webhooks'],
  ['app/add-ons/open-api/webhooks/create', 'app/integrations/webhooks/create'],
  ['app/add-ons/open-api/webhooks/:webhookId', 'app/integrations/webhooks/:webhookId'],
  ['app/add-ons/zapier/view', 'app/integrations/zapier'],
  ['app/add-ons/adp/view', 'app/integrations/adp'],
]

export function legacyIntegrationRedirects(matchUrl: string): React.ReactElement[] {
  return LEGACY_REDIRECTS.map(([from, to]) => (
    <Route
      key={from}
      exact
      path={`${matchUrl}${from}`}
      render={({ match, location }) => <Redirect to={{ pathname: generatePath(`${matchUrl}${to}`, match.params), search: location.search, hash: location.hash }} />}
    />
  ))
}
